import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    selectedStudies: [],
    selectedFiles: [],
}

const selectableSlice = createSlice({
    name: 'selectables',
    initialState,
    reducers: {
        selectAll: (state, { payload }) => {
            if (payload.acqdates) {
                state.selectedStudies = payload.acqdates
            }
            state.selectedFiles = [...new Set([...state.selectedFiles, ...payload.fileIds])]
        },
        unSelectAll: state => {
            state.selectedStudies = []
            state.selectedFiles = []
        },
        unSelectAllFiltered: (state, { payload }) => {
            state.selectedStudies = []
            state.selectedFiles = state.selectedFiles.filter(f => !payload.fileIds.includes(f))
        },
        selectStudy: (state, { payload }) => {
            state.selectedStudies = [...new Set([...state.selectedStudies, payload])]
        },
        unSelectStudy: (state, { payload }) => {
            state.selectedStudies = state.selectedStudies.filter(s => s !== payload)
        },
        selectStudyFiles: (state, { payload }) => {
            if (payload.date) {
                state.selectedStudies = [...new Set([...state.selectedStudies, payload.date])]
            }
            state.selectedFiles = [...new Set([...state.selectedFiles, ...payload.fileIds])]
        },
        unSelectStudyFiles: (state, { payload }) => {
            if (payload.date) {
                state.selectedStudies = state.selectedStudies.filter(s => s !== payload.date)
            }
            state.selectedFiles = state.selectedFiles.filter(f => !payload.fileIds.includes(f))
        },
        selectFile: (state, { payload }) => {
            state.selectedFiles = [...new Set([...state.selectedFiles, payload.fileId])]
        },
        unSelectFile: (state, { payload }) => {
            if (payload.date) {
                state.selectedStudies = state.selectedStudies.filter(s => s !== payload.date)
            }
            state.selectedFiles = state.selectedFiles.filter(f => !payload.fileIds.includes(f))
        },
    },
})

export default selectableSlice
